import { render, staticRenderFns } from "./BazarCompraDirecta.vue?vue&type=template&id=b651c3a0&"
import script from "./BazarCompraDirecta.vue?vue&type=script&lang=js&"
export * from "./BazarCompraDirecta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports